export default "__VITE_ASSET__DCHcs37N__"